import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/AdvanceDrivers/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/AdvanceDrivers/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/AdvanceDrivers/GetById`, payload),
    Add: (payload) => Repository.post(`/api/AdvanceDrivers/Add`, payload),
    Copy: (payload) => Repository.post(`/api/AdvanceDrivers/Copy`, payload),
    Edit: (payload) => Repository.post(`/api/AdvanceDrivers/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/AdvanceDrivers/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/AdvanceDrivers/ChangeStatus`, payload),
}